import { useEffect, useState } from "react";
import { getGenres } from "../services/commonService";
import { Genre } from "../types/index.d";

type UseGenre = {
    genres: Genre[];
    fetchGenres: () => void;
}

export const useGenre = (): UseGenre => {
    const [genres, setGenres] = useState<Genre[]>([]);

    useEffect(() => {
        fetchGenres();
    }, []);

    const fetchGenres = async () => {
        getGenres().then(response => {
            setGenres([{ id: 0, name: 'All' }, ...response.data]);
        }).catch(error => {
            console.error('Error fetching genres:', error);
        });
    }

    return { genres, fetchGenres };
}